import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import {createRequestOption, createRequestBody} from '../../shared/util';
import {environment} from '../../../environments/environment';


@Injectable({ providedIn: 'root' })
export class LifeHeroService {
  public resourceUrl = environment.SERVER_API_URL;

  constructor(protected http: HttpClient) {}
 
  resAll(req){
    const options = createRequestOption(req);
    return this.http.get(this.resourceUrl + 'life-hero/resource/all', {params: options});
  }
  getSummary(req){
    const options = createRequestOption(req);
    return this.http.get(this.resourceUrl + 'life-hero/consult-request/summary/org-assignment', {params: options});
  }
  queryAgencyOrganizations(req){
    const options = createRequestBody(req);
    return this.http.get(this.resourceUrl + 'life-hero/resource/agency-organizations/', {params: options} );
  }
  queryCustomerList(req){
    const options = createRequestBody(req);
    return this.http.post(this.resourceUrl + 'life-hero/user-crm/list', options , { observe: 'response' });
  }
  queryCustomerById(id){
    return this.http.get(this.resourceUrl + 'life-hero/user-crm/' + id);
  }
  querySurveyList(req){
    const options = createRequestBody(req);
    return this.http.post(this.resourceUrl + 'life-hero/user-survey/list', options , { observe: 'response' });
  }
  querySupportList(req){
    const options = createRequestBody(req);
    return this.http.post(this.resourceUrl + 'life-hero/crm-support/list', options , { observe: 'response' });
  }
  queryDealList(req){
    const options = createRequestBody(req);
    return this.http.post(this.resourceUrl + 'life-hero/deal/list', options , { observe: 'response' });
  }
  queryRequestAssistanceList(body){
    return this.http.post(this.resourceUrl + 'life-hero/consult-request/list', body);
  }
  queryAUMForInvestor(code){
    return this.http.get(this.resourceUrl  + 'api/user/code/' + code);
  }
  queryRequestAssistanceById(id){
    return this.http.get(this.resourceUrl + 'life-hero/consult-request/' + id);
  }
  queryContractList(body){
    return this.http.post(this.resourceUrl + 'life-hero/contracts/list', body );
  }
  queryContractById(id){
    return this.http.get(this.resourceUrl + 'life-hero/contracts/' + id);
  }
  queryAdvisorList(req){
    const options = createRequestBody(req);
    return this.http.post(this.resourceUrl + 'life-hero/advise/list', options , { observe: 'response' });
  }
  queryDistricts(req) {
    const options = createRequestOption(req);
    return this.http.get(this.resourceUrl + 'life-hero/resource/districts', { params: options, observe: 'response' });
  }
  queryWards(req) {
    const options = createRequestOption(req);
    return this.http.get(this.resourceUrl + 'life-hero/resource/wards', { params: options, observe: 'response' });
  }
  updateProfileCustomer(body) {
    return this.http.put(this.resourceUrl + 'life-hero/user-crm/' + body.id, body);
  }
  createContract(body) {
    return this.http.post(this.resourceUrl + 'life-hero/contract/', body);
  }
  createSupport(body) {
    return this.http.post(this.resourceUrl + 'life-hero/crm-support/', body);
  }
  createDeal(body) {
    return this.http.post(this.resourceUrl + 'life-hero/deal/', body);
  }
  createAdvisor(body) {
    return this.http.post(this.resourceUrl + 'life-hero/advise/register' , body);
  }
  queryProducts(req){
    const options = createRequestBody(req);
    return this.http.post(this.resourceUrl + 'life-hero/resource/products/filter', options );
  }
  updateStatusContract(body) {
    return this.http.put(this.resourceUrl + 'life-hero/contract/' + body.id + '/update-status', body);
  }
  updateContract(body) {
    return this.http.put(this.resourceUrl + 'life-hero/contract/' + body.id, body);
  }
  updateDeal(body) {
    return this.http.put(this.resourceUrl + 'life-hero/deal/' + body.id, body);
  }
  updateSurvey(body) {
    return this.http.put(this.resourceUrl + 'life-hero/user-survey/' + body.id, body);
  }
  updateSupport(body) {
    return this.http.put(this.resourceUrl + 'life-hero/crm-support/' + body.id, body);
  }
  updateAdvisor(body) {
    return this.http.put(this.resourceUrl + 'life-hero/advise/' + body.id , body);
  }
  assignAgencyOrganizationList(body){
    return this.http.put(this.resourceUrl + 'life-hero/consult-request/' + body.id + '/assign-agency-org', body);
  }
  queryOrgAgency(req){
    const options = createRequestOption(req);
    return this.http.get(this.resourceUrl + 'life-hero/resource/agency-organizations/', {params: options});
  }
  queryPartnerAgency(req) {
    const options = createRequestOption(req);
    return this.http.get(this.resourceUrl + 'life-hero/resource/agency-partners/', {params: options});
  }
  queryAgencyOrganAssignRule(req) {
    const options = createRequestOption(req);
    return this.http.get(this.resourceUrl + 'life-hero/config/agency-org-assign-rule/list', {params: options});
  }
  updateAgencyOrganAssignRule(body) {
    return this.http.post(this.resourceUrl + 'life-hero/config/agency-org-assign-rule', body);
  }
}
